/**
 * @generated SignedSource<<160b137a861d6239a211839905aefbef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Position = "freelancer" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type RateExplanation_Job$data = {
  readonly clientRate: {
    readonly value: number;
  } | null | undefined;
  readonly currency: {
    readonly code: string | null | undefined;
  } | null | undefined;
  readonly freelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly margin: number | null | undefined;
  readonly minClientRate: {
    readonly value: number;
  } | null | undefined;
  readonly minFreelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly minMarginUsd: number | null | undefined;
  readonly positionTypes: ReadonlyArray<Position>;
  readonly rateMode: RateMode | null | undefined;
  readonly " $fragmentType": "RateExplanation_Job";
};
export type RateExplanation_Job$key = {
  readonly " $data"?: RateExplanation_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"RateExplanation_Job">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RateExplanation_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minClientRate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "clientRate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "freelancerRate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minFreelancerRate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "margin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMarginUsd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Currency",
      "kind": "LinkedField",
      "name": "currency",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "26c0c65900291e355c5cc458b45a1173";

export default node;
